export default function BrandStory() {
  const team = [
    {
      id: 1,
      image:
        "https://public.readdy.ai/ai/img_res/3fe56ce524b32ec57a93f35213686cb4.jpg",
    },
    {
      id: 2,
      image:
        "https://readdy.ai/api/search-image?query=Creative%20Black%20African%20American%20woman%20fashion%20stylist%20portrait%20sophisticated%20dark%20skin%20melanin%20rich%20professional%20warm%20sepia%20tone%20filter%20elegant%20studio%20lighting%20artistic%20headshot%20natural%20beauty%20glowing%20skin&width=200&height=200&seq=abexia-team-blackwoman-2&orientation=squarish",
    },
    {
      id: 3,
      image:
        "https://readdy.ai/api/search-image?query=Black%20African%20American%20woman%20boutique%20owner%20portrait%20elegant%20dark%20skin%20melanin%20rich%20professional%20warm%20sepia%20tone%20filter%20artistic%20studio%20lighting%20sophisticated%20headshot%20radiant%20smile%20natural%20hair&width=200&height=200&seq=abexia-team-blackwoman-3&orientation=squarish",
    },
    {
      id: 4,
      image:
        "https://readdy.ai/api/search-image?query=Black%20African%20American%20woman%20fashion%20curator%20portrait%20professional%20dark%20skin%20melanin%20rich%20elegant%20warm%20sepia%20tone%20filter%20artistic%20studio%20lighting%20creative%20headshot%20beautiful%20natural%20features%20confident%20expression&width=200&height=200&seq=abexia-team-blackwoman-4&orientation=squarish",
    },
  ];

  return (
    <section id="about" className="bg-white py-32 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="mb-12">
          <span className="text-sm text-[#936A0B] font-medium">/OUR STORY</span>
        </div>

        <p className="text-4xl font-light text-[#574407] leading-relaxed mb-16 text-left font-serif">
          At ABEXIA, we celebrate the beauty of womanhood and the joy of childhood. Our women&apos;s fashion is curated
          for those who appreciate timeless elegance, while our children&apos;s party bags bring magic to every
          celebration.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="text-sm text-gray-400 flex items-center gap-2">
            <span className="w-1.5 h-1.5 bg-gray-400 rounded-full"></span>
            <span>EST. 2024</span>
          </div>

          <div className="flex items-center gap-6">
            <div className="flex -space-x-4">
              {team.map((member) => (
                <div
                  key={member.id}
                  className="w-20 h-20 rounded-full overflow-hidden border-4 border-white shadow-md"
                  style={{ filter: "sepia(30%)" }}
                >
                  <img
                    src={member.image}
                    alt="Team Member"
                    className="w-full h-full object-cover object-top"
                    onError={(e) => {
                      // Fallback to a placeholder image if the remote image fails to load
                      e.currentTarget.src =
                        "https://via.placeholder.com/200?text=No+Image";
                    }}
                  />
                </div>
              ))}
            </div>
            <p className="text-base text-[#574407] font-medium">
              Crafted by passionate designers
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
